/**
 * Дефис, которым магазин написал слово, — тот же дефис.
 *
 * В Юникоде дефисов много: обычный `-` (U+002D), типографский `‐` (U+2010),
 * неразрывный `‑` (U+2011), цифровой `‒` (U+2012), знак минуса `−` (U+2212).
 * Человек их не различает — и не должен. А правило, выписанное с обычным
 * дефисом, на любом другом молча перестаёт срабатывать.
 *
 * Поймано на Wildberries 07.08.2026. Страница товара объявляет себя
 * «Интернет‑магазин Wildberries: широкий ассортимент товаров» — и это
 * вывеска, а не название вещи. Правило «страница назвала себя служебной»
 * такие названия отсеивает и заведено ровно для этого случая, но у WB дефис
 * неразрывный, и правило проходило мимо. Человек, нажавший закладку на
 * настоящей странице Wildberries, получал желание «Интернет‑магазин
 * Wildberries: широкий ассортимент товаров» вместо ленты за 1630 ₽.
 *
 * Одна страница — случайность, но неразрывный дефис нашёлся на двенадцати
 * страницах корпуса, а цифровой ещё на двух. Значит это не про Wildberries,
 * а про то, что правила сравнивают знак вместо смысла.
 *
 * ТИРЕ ЗДЕСЬ НЕТ И БЫТЬ НЕ ДОЛЖНО. Короткое `–` (U+2013) и длинное `—`
 * (U+2014) — не дефисы: они не соединяют слово, а отделяют приписку магазина
 * от названия товара. Разбор на них опирается, когда режет хвост «— Магазин»,
 * и превратить их в дефис значит сломать это разделение.
 */

/**
 * Замена ровно посимвольная, один знак на один.
 *
 * Это не мелочь, а условие пользования: часть правил ищет по нормализованной
 * строке, а режет по исходной — так человек видит название таким, каким его
 * написал магазин. Стоит замене изменить длину, и все такие срезы поедут.
 * Поэтому мягкий перенос (U+00AD), который надо было бы удалять, сюда
 * не входит: он потребует другого обращения.
 */
const ДЕФИСОПОДОБНЫЕ = /[‐‑‒−]/g;

export function обычныеДефисы(текст: string): string {
  return текст.replace(ДЕФИСОПОДОБНЫЕ, '-');
}
